import { Components, filledInputClasses, Theme } from '@mui/material';

export function getMuiFilledInput(theme: Theme): Components['MuiFilledInput'] {
  return {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.shape.borderRadius,
        boxShadow: `0 0 0 2px ${theme.palette.background.default}`,
        transition: 'all 0.3s',

        '& input': {
          '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
            {
              boxShadow: `0 0 0 30px ${theme.palette.background.default} inset`,
            },
        },

        [`&&.${filledInputClasses.disabled}`]: {
          backgroundColor: theme.palette.grey[100],
          boxShadow: `0 0 0 2px ${theme.palette.grey[100]}`,

          '& input': {
            '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
              {
                boxShadow: `0 0 0 30px ${theme.palette.grey[100]} inset`,
              },
          },
        },

        '&:hover': {
          boxShadow: `0 0 0 2px ${theme.palette.grey[100]}`,
          backgroundColor: theme.palette.grey[100],

          '& input': {
            '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
              {
                boxShadow: `0 0 0 30px ${theme.palette.grey[100]} inset`,
              },
          },
        },

        [`&&.${filledInputClasses.focused}`]: {
          backgroundColor: theme.palette.background.default,

          '& input': {
            '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
              {
                boxShadow: `0 0 0 30px ${theme.palette.background.default} inset`,
              },
          },
        },
      },
      input: {
        padding: 0,
        transition: 'all 0.3s',

        '&&': {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
      },
    },
  };
}
